import { Animation } from '../System/Animation/animation';
import { Ease, EaseMode } from '../System/Animation/animationEasing';
import { SystemCamera } from '../System/systemCamera';

export class UiCameraRotate {
    private system: SystemCamera;

    private anim: Animation;

    constructor(
        system: SystemCamera,
    ) {
        this.system = system;

        this.anim = new Animation(system, 20);
        this.anim.setEasing(Ease.Cubic, EaseMode.InOut);

        let down = false;
        this.system.canvas.addEventListener('pointerdown', () => {
            down = true;
            this.anim.stop();
        });
        this.system.canvas.addEventListener('pointerup', () => {
            down = false;
            setTimeout(() => {
                if (!down && this.started) this.animate();
            }, 2000);
        });
    }

    private started = false

    public set start(v : boolean) {
        this.started = v;
        if (v) this.animate();
        else this.anim.stop();
    }

    private animate() {
        //! Stop animation first to make sure the last currentTimeout is cleared
        let easing = 0;
        this.anim.infinite(() => {
            easing++;
            const speed = Math.min(easing / 100, 1) ** 2;
            this.system.arcCamera.alpha += 0.01 * speed;
        });
    }
}
